import { render, staticRenderFns } from "./Address-Card.vue?vue&type=template&id=1aec173b&scoped=true&"
import script from "./Address-Card.vue?vue&type=script&lang=js&"
export * from "./Address-Card.vue?vue&type=script&lang=js&"
import style0 from "./Address-Card.vue?vue&type=style&index=0&id=1aec173b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec173b",
  null
  
)

export default component.exports